
export function useDescription() {
  const description = [
    'Showing the historical and long-term forecast development of crop commodities’ prices, as predicted by several different sources',
    'Source: USDA Prices, ICE, NYSE (Historical Prices), IHS - GI, USDA Projections, FAPRI, World Bank, OECD-FAO (Forecast Prices)',
  ];
  return description;
}